import React from 'react';
import Tabs from 'components/utilities/tabs/Tabs';
import { useSelector } from 'react-redux';

// Import helrpes
import { documentsTabs } from './helpers/index';

const DocumentsTabs = () => {
	const { languages: contentTranslationLanguages } = useSelector(
		({ content_translations }) => content_translations.language_list
	);
	return <Tabs tabs={documentsTabs(contentTranslationLanguages)} />;
};

export default DocumentsTabs;
